<div class="modal-header">
  <h4 class="modal-title">
    Enviar notificación
    <span class="d-block text-muted small fw-normal">
      Casa {{ houseFlat?.number }}
    </span>
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">

  <form
    id="formNotification"
    [formGroup]="formNotification"
    (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12 mb-3 form-group">
          <label for="title" class="form-label">Título</label>
          <input
            type="text"
            id="title"
            class="form-control"
            formControlName="title"
            placeholder="Ingrese el título de la notificación"
            [ngClass]="{
              'is-invalid': submitted && formControls['title'].errors
            }">
          @if(submitted && formControls['title'].errors) {
            <div class="invalid-feedback" role="alert">
              @if(formControls['title'].errors['required']) {
                <div>
                  Por favor, ingrese el título de la notificación
                </div>
              }
            </div>
          }
        </div>

        <div class="col-12 mb-3 form-group">
          <label for="subtitle" class="form-label">Subtítulo</label>
          <textarea
            id="subtitle"
            class="form-control"
            formControlName="subtitle"
            rows="3"
            placeholder="Ingrese el subtítulo de la notificación"
            [ngClass]="{
              'is-invalid': submitted && formControls['subtitle'].errors
            }"></textarea>
          @if(submitted && formControls['subtitle'].errors) {
            <div class="invalid-feedback" role="alert">
              @if(formControls['subtitle'].errors['required']) {
                <div>
                  Por favor, ingrese el subtítulo de la notificación
                </div>
              }
            </div>
          }
        </div>

      </div>
    </div>
  </form>

</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formNotification"
      class="btn btn-primary w-100">
      Enviar
    </button>
  </div>
</div>
